import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ApiProvider } from './context/context';
import { AuthProvider } from 'context/AuthContext';
import { QueryClient,QueryClientProvider } from '@tanstack/react-query';


const queryClient = new QueryClient({
  defaultOptions : {
    queries:{
      refetchOnWindowFocus:false,
      retry:1,
      staleTime: 5 * 60 * 1000,
    }
  }
})

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
      <React.StrictMode>
        <AuthProvider>
          <BrowserRouter>
            <ApiProvider>
              <QueryClientProvider client={queryClient}>
                <App />
              </QueryClientProvider>
            </ApiProvider>
          </BrowserRouter>
        </AuthProvider>
      </React.StrictMode>,
    </React.StrictMode>
);


